module.exports = __webpack_public_path__ + "static-kuaikan-h5-fe/img/header.3d1c1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/act/202102/link_vip/img/header.png
// module id = Whif
// module chunks = 1